import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { RoutingErrorComponent } from '../routing-error/routing-error.component';
import { TripGenerationComponent } from '../trip-generation/trip-generation.component';

@Component({
  selector: 'app-trips-v3',
  templateUrl: './trips-v3.component.html',
  styleUrls: ['./trips-v3.component.scss']
})
export class TripsV3Component {

  startTimer: boolean = false;
  tripViewFlag: boolean = false;
  headErrorFlag: boolean = false;
  successFlag: boolean = true;
  errorFlag: boolean = true;
  singleList: any[] = [];
  errorSingleList: any[] = [];
  errorList: any[] = [];
  tripList: any[] = [];
  tripvehs: any[] = [];
  cities: any[] = [];
  sites: any[] = [];
  sub: Subscription;
  selectedCityId: any;
  selectedCity: any = '';
  selectedSite: any = '';
  siteId: any = '';
  selectedShiftType: any;
  tripDate: any;
  generatedShift: any;
  headErrorMsg: any;
  shiftTypes: any[] = ["IN", "OUT", "ALL"];
  activeTabId = 1;
  generateMsg: any;
  siteDDSettings = {
    itemsShowLimit: 1,
    idField: "siteId",
    textField: "siteName",
    allowSearchFilter: true,
    searchPlaceholderText: "Search Site"
  };
  hoveredTrip: any = null;
  totalTrips: any = [];

  constructor(
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    private serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    setTimeout(() => {
      let locationsList = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.locationsList);
      let sitesList = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.sitesList);
      let location = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.location);
      let site = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.site);
      let date = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.date);
      let shifttype = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.shiftType);
      let tripViewFlag = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.tripViewFlag);
      const filterSites = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.filterSites);
      const saveTripMirroringFlag = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.saveTripMirroringFlag);
      if (locationsList && sitesList && location && site && date && shifttype && tripViewFlag) {
        this.cities = locationsList;
        this.sites = sitesList;
        this.selectedCityId = location;
        this.selectedCity = location.target.value;
        if (filterSites.length > 0) {
          this.siteId = filterSites;
        }
        this.onChangeSite(this.siteId);
        this.tripDate = date;
        this.selectedShiftType = shifttype;
        if (saveTripMirroringFlag != null && saveTripMirroringFlag) {
          this.generatedShift = this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION.shiftId);
          this.startTimer = true;
          this.showTrips(true);
        } else {
          this.startTimer = false;
          this.showTrips(false);
        }
        this.startInterval();
        this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.tripViewFlag, false);
        this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.saveTripMirroringFlag, false);
      } else {
        this.selectedShiftType = this.shiftTypes[2];
        this.tripDate = new Date();
        this.loadCities();
        this.startInterval();
      }
    }, 0);
  }

  ngOnDestroy() {
    this.stopInterval();
  }

  startInterval() {
    if (this.generateMsg) {
      this.sub = interval(12000).subscribe(val => {
        if (this.startTimer) this.refreshTrips(true);
      });
    } else {
      this.sub = interval(12000).subscribe(val => {
        if (this.startTimer) this.showTrips(true);
      });
    }
  }

  stopInterval() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  loadCities() {
    let companyid: number = +this.serviceLocalStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyid, success => {
      if (success.status == 200) {
        this.cities = success.body;
        if (this.cities.length > 0) {
          this.selectedCity = this.cities[0].locationId;
          this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
        }
      } else {
        this.cities = [];
        this.notifyService.showInfo("No Location Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  getSitesByCityId(cityId) {
    this.selectedCityId = cityId;
    this.apiService.doGetRequestWithResponse(ApiConstants.getSiteByLocationId + cityId.target.value, success => {
      if (success.status == 200) {
        this.sites = success.body.dataList.content;
        if (this.sites.length > 0) {
          this.siteId = [this.sites[0]];
          this.onChangeSite(this.siteId);
        }
      } else {
        this.sites = [];
        this.notifyService.showInfo("No Site Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  onChangeSite(event) {
    const selectedIds = event.map(site => site.siteId);
    const siteArr = this.sites.filter(site => selectedIds.includes(site.siteId));
    this.selectedSite = siteArr[0];
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return dt + "/" + mm + "/" + d.getFullYear();
  }

  showTrips(timer) {
    const selectedSiteIds = this.siteId.map(item => item.siteId).join(',');
    this.errorList = [];
    if (this.tripDate && selectedSiteIds) {
      if (!timer)
        this.ngxLoader.start();
      this.apiService.doGetRequestWithResponse(ApiConstants.getTripStatusV3 + this.formatDate(this.tripDate) + '&siteIds=' + selectedSiteIds +
        '&logType=' + this.selectedShiftType, success => {
          this.ngxLoader.stop();
          this.tripList = [];
          this.headErrorFlag = false;
          if (success.status == 200) {
            this.totalTrips = success.body;
            success.body.forEach(element => {
              if (element) {
                if (!element.ERROR) {
                  this.tripList.push({
                    time: element.SHIFT,
                    site: element.SITE,
                    totalEmp: element.BOOKING,
                    femaleEmp: element.FEMALE,
                    totalTrips: element.TRIPS,
                    totalAdhocEmp: element.ADHOCBOOKING,
                    escortTrip: element.SECURITY,
                    SHIFTID: element.SHIFTID,
                    MSG: element.MSG,
                    ERRORMSG: element.ERRORMSG,
                    isTripStatsAvailable: element.ISTRIPSTATS
                  });
                  this.tripvehs.push({
                    Indica: element.Indica,
                    TT: element.TT
                  });
                  if (element.totalTrips > 0 && element.MSG == "")
                    this.tripViewFlag = true;
                  if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
                    this.startTimer = false;
                  }
                } else {
                  this.errorList.push({
                    ERROR: element.ERROR,
                    SHIFTLOG: element.SHIFTLOG,
                    SITENAME: element.SITENAME,
                    TRIPDATE: element.TRIPDATE,
                    ERROR1: element.ERROR1,
                    ERROR2: element.ERROR2,
                    ERROR3: element.ERROR3
                  });
                }
              }
            });
            if (this.tripList.length > 0) {
              this.getErrorHead();
            }
            if (this.errorList.length > 0) {
              this.showTripGenSuccess();
            }
          } else {
            this.ngxLoader.stop();
            this.notifyService.showInfo("No Data Found", null);
          }
        }, error => {
          if (error.status == 500) {
            this.notifyService.showInfo("Please wait for a moment..", null);
          } else {
            this.ngxLoader.stop();
            this.notifyService.showInfo("Please wait..", null);
          }
          this.startTimer = true;
        });
    } else {
      this.notifyService.showWarning("Site / Date is not selected", null);
    }
  }

  getErrorHead() {
    if (this.tripList[0] != null && this.tripList[0].ERRORMSG) {
      this.headErrorMsg = this.tripList[0].ERRORMSG;
      this.headErrorFlag = true;
    }
  }

  showTripGenSuccess() {
    if (this.errorList) {
      this.successFlag = false;
      this.errorFlag = false;
      this.singleList = [];
      this.errorSingleList = [];
      this.errorList.forEach(element => {
        if (element && element.ERROR != null) {
          if (element.ERROR == "SUCC") {
            this.successFlag = true;
            this.tripViewFlag = true;
            this.singleList.push({
              ERROR: element.ERROR,
              SHIFTLOG: element.SHIFTLOG,
              SITENAME: element.SITENAME,
              TRIPDATE: element.TRIPDATE,
              ERROR1: element.ERROR1,
              ERROR2: element.ERROR2,
              ERROR3: element.ERROR3
            });
          } else if (element.ERROR == "ERR") {
            this.errorFlag = true;
            this.errorSingleList.push({
              ERROR: element.ERROR,
              SHIFTLOG: element.SHIFTLOG,
              SITENAME: element.SITENAME,
              TRIPDATE: element.TRIPDATE,
              ERROR1: element.ERROR1,
              ERROR2: element.ERROR2,
              ERROR3: element.ERROR3
            });
          }
        }
      });
      if (this.successFlag) {
        this.tripViewFlag = false;
        this.openErrorDialog(this.singleList, true);
      } else if (this.errorFlag) {
        this.openErrorDialog(this.errorSingleList, false);
      }
    }
  }

  openErrorDialog(data: any[], type: boolean): void {
    this.generateMsg = '';
    let d = { type: type, data: data };
    this.successFlag = false;
    this.errorFlag = false;
    this.dialog.open(RoutingErrorComponent, {
      data: d,
      disableClose: true,
      width: "500px"
    });
  }

  viewDetailedTrip(shiftId) {
    const shiftwiseSiteIds = this.totalTrips.filter(item => item.SHIFTID === shiftId);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.locationsList, this.cities);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.sitesList, this.sites);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.location, this.selectedCityId);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.site, this.selectedSite);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.date, this.tripDate);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftType, this.selectedShiftType);
    this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.filterSites, this.siteId);
    this.router.navigate(["/myatom/routing/tripviewv3", shiftwiseSiteIds[0].SITEIDS, shiftId, this.formatDate(this.tripDate)]);
  }

  generate(shift) {
    const shiftwiseSiteIds = this.totalTrips.filter(item => item.SHIFTID === shift.SHIFTID);
    this.errorFlag = true;
    let tripData;
    if (this.tripDate) {
      tripData = {
        requestedDate: this.formatDate(this.tripDate),
        site: this.selectedSite,
        shift: shift,
        selectedSite: shiftwiseSiteIds[0].SITEIDS
      };
      this.openDialog(tripData);
    } else {
      this.notifyService.showWarning("date/site is empty!", null);
    }
  }

  openDialog(data: any): void {
    this.generateMsg = '';
    let dialogRef = this.dialog.open(TripGenerationComponent, {
      width: 'auto',
      data: { ...data, tripsv3: true },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.generateMsg = result.MSG;
        if (result.status === 'onMirroringSubmit') {
          this.generatedShift = result.shiftId;
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.locationsList, this.cities);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.sitesList, this.sites);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.location, this.selectedCityId);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.site, this.selectedSite);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.date, this.tripDate);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftType, this.selectedShiftType);
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftId, result.shiftId);
        } else {
          this.generatedShift = result.shiftId;
          this.startTimer = true;
          this.tripList = [];
          this.refreshTrips(false);
        }
      }
    });
  }

  refreshTrips(timer) {
    const selectedSiteIds = this.siteId.map(item => item.siteId).join(',');
    this.errorList = [];
    if (this.tripDate && selectedSiteIds) {
      if (!timer)
        this.ngxLoader.start();
      this.apiService.doGetRequestWithResponse(ApiConstants.getTripStatusV3 + this.formatDate(this.tripDate) + '&siteIds=' + selectedSiteIds +
        '&logType=' + this.selectedShiftType, success => {
          this.headErrorFlag = false;
          if (success.status == 200) {
            success.body.forEach(element => {
              if (element) {
                if (element.MSG == '') {
                  this.ngxLoader.stop()
                  if (!element.ERROR) {
                    this.tripList.push({
                      time: element.SHIFT,
                      site: element.SITE,
                      totalEmp: element.BOOKING,
                      femaleEmp: element.FEMALE,
                      totalTrips: element.TRIPS,
                      totalAdhocEmp: element.ADHOCBOOKING,
                      escortTrip: element.SECURITY,
                      SHIFTID: element.SHIFTID,
                      MSG: element.SHIFTID == this.generatedShift ? 'Generating' : element.MSG,
                      ERRORMSG: element.ERRORMSG,
                      isTripStatsAvailable: element.ISTRIPSTATS
                    });
                    this.tripvehs.push({
                      Indica: element.Indica,
                      TT: element.TT
                    });
                    if (element.totalTrips > 0 && element.MSG == "")
                      this.tripViewFlag = true;
                    if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
                      this.startTimer = false;
                    }
                  } else {
                    this.errorList.push({
                      ERROR: element.ERROR,
                      SHIFTLOG: element.SHIFTLOG,
                      SITENAME: element.SITENAME,
                      TRIPDATE: element.TRIPDATE,
                      ERROR1: element.ERROR1,
                      ERROR2: element.ERROR2,
                      ERROR3: element.ERROR3
                    });
                  }
                 }else {
                  this.ngxLoader.stop()
                  if (!element.ERROR) {
                    this.tripList.push({
                      time: element.SHIFT,
                      site: element.SITE,
                      totalEmp: element.BOOKING,
                      femaleEmp: element.FEMALE,
                      totalTrips: element.TRIPS,
                      totalAdhocEmp: element.ADHOCBOOKING,
                      escortTrip: element.SECURITY,
                      SHIFTID: element.SHIFTID,
                      MSG: element.MSG,
                      ERRORMSG: element.ERRORMSG,
                      isTripStatsAvailable: element.ISTRIPSTATS
                    });
                    this.tripvehs.push({
                      Indica: element.Indica,
                      TT: element.TT
                    });
                    if (element.totalTrips > 0 && element.MSG == "")
                      this.tripViewFlag = true;
                    if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
                      this.startTimer = false;
                    }
                  } else {
                    this.errorList.push({
                      ERROR: element.ERROR,
                      SHIFTLOG: element.SHIFTLOG,
                      SITENAME: element.SITENAME,
                      TRIPDATE: element.TRIPDATE,
                      ERROR1: element.ERROR1,
                      ERROR2: element.ERROR2,
                      ERROR3: element.ERROR3
                    });
                  }
                }
              }
            });
            if (this.tripList.length > 0) {
              this.getErrorHead();
            }
            if (this.errorList.length > 0) {
              this.showTripGenSuccess();
            }
          } else {
            this.ngxLoader.stop();
            this.notifyService.showInfo("No Data Found", null);
          }
        }, error => {
          if (error.status == 500) {
            this.notifyService.showInfo("Please wait for a moment..", null);
          } else {
            this.ngxLoader.stop();
            this.notifyService.showInfo("Please wait..", null);
          }
          this.startTimer = true;
        });
    } else {
      this.notifyService.showWarning("Site / Date is not selected", null);
    }
  }

  onItemSelect() {
    this.onChangeSite(this.siteId);
  }

  OnItemDeSelect() {
    this.onChangeSite(this.siteId);
  }

  onSelectAll(item) {
    this.siteId = item;
    this.onChangeSite(this.siteId);
  }

  onDeSelectAll() {
    this.siteId = [];
    this.selectedSite = '';
  }

  getSites(siteString: string): string[] {
    return siteString ? siteString.split(',').map(s => s.trim()) : [];
  }

  showPopup(trip: any) {
    this.hoveredTrip = trip;
  }

  hidePopup() {
    this.hoveredTrip = null;
  }

}
